/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_send_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send idea`)
};

const es_contact_send_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar idea`)
};

const de_contact_send_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idee senden`)
};

const nl_contact_send_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idee versturen`)
};

const fr_contact_send_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer l'idée`)
};

const it_contact_send_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia idea`)
};

const pt_br2_contact_send_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar ideia`)
};

const pt_contact_send_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar ideia`)
};

const ja_contact_send_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイデアを送る`)
};

const zh_contact_send_idea = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送创意`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_send_idea = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_send_idea(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_send_idea", locale)
	if (locale === "en") return en_contact_send_idea(inputs)
	if (locale === "es") return es_contact_send_idea(inputs)
	if (locale === "de") return de_contact_send_idea(inputs)
	if (locale === "nl") return nl_contact_send_idea(inputs)
	if (locale === "fr") return fr_contact_send_idea(inputs)
	if (locale === "it") return it_contact_send_idea(inputs)
	if (locale === "pt-BR") return pt_br2_contact_send_idea(inputs)
	if (locale === "pt") return pt_contact_send_idea(inputs)
	if (locale === "ja") return ja_contact_send_idea(inputs)
	return zh_contact_send_idea(inputs)
};